
import route from './route';
import message from './message';
import layout from './layout';

export default {
  index: {
    whySelect: '為什麼選擇 Prestige 學生公寓？',
    whySelectDesc1: 'Prestige系列學生公寓，致力於為全球留學生打造一致的高品質住宿體驗。無論你身在何處，',
    whySelectDesc2: '我們都以統一的標準化管理與貼心的服務，為你提供一個安全、舒適、溫暖如家的居住環境。',
    footerDesc: '專為學生設計的優質生活空間，提供舒適、安全、便利的住宿環境。',
    copyright: '2026 PRESTIGE 32, 保留所有權利。',
    advantagesTitle: '公寓優勢',
    roomTypeTitle: '精緻的房間',
    roomVisit: '參觀房間',
    locationTitle: '優越位置',
    arriveInstitutionTime: '到校交通時間',
    arriveTransportTime: '交通時間',
    feeTitle: '費用說明',
    contactUsTitle: '預約參觀或了解更多信息',
    contactUsDesc: '預約參觀或了解更多資訊',
    download: '下載資料',
    address: '地址',
    phone: '電話',
    email: 'Email',
    menuHome: '首頁',
    menuFeatures: '設施',
    menuRoomType: '房間類型',
    menuLocation: '位置',
    menuContactUs: '聯絡我們',
    quickLinks: '快速鏈接',
    contactInformation: '聯繫方式',
    footerAddress: '香港科學園第一期2W大廈5樓502室',
    footerPhone: '(852)2110 3835',
  },
  route,
  message,
  ...layout,
};
